import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { get_promotion_details, get_promotion_labels } from '../../core/_request'
import { useAuth } from '../../../auth'
import { promotionFieldMapping } from './fieldMapping'
import DetailSection from './DetailSection'
import { KTCardBody } from '../../../../../general/helpers'
import { PageTitle } from '../../../../../general/layout/core'
import { getBreadcrumbs } from '../../../../routing/Breadcrumbs'
import { useIntl } from 'react-intl'

export default function PromotionDetails() {
  const { id } = useParams()
  const { auth } = useAuth()
  const [details, setDetails] = useState<any>()
  const [labels, setLabels] = useState<{
    [name: string]: string
  }>({})
  const [detailsLoader, setDetailsLoader] = useState<boolean>()
  const intl = useIntl()

  function fetchAllLabels(obj: any) {
    const result = {}
    function recurse(current, path) {
      for (const key in current) {
        const newPath = path ? `${path}.${key}` : key
        if (typeof current[key] === 'object') {
          recurse(current[key], newPath)
        } else {
          result[newPath] = current[key]
        }
      }
    }
    recurse(obj, '')
    return result
  }

  useEffect(() => {
    setDetailsLoader(true)
    get_promotion_labels(auth?.accessToken ?? '').then((res) => {
      const { data } = res
      let tempLabels: any = data?.[0]?.['labels']
      setLabels(fetchAllLabels(tempLabels))
    })
    get_promotion_details(auth?.accessToken ?? '', id).then((res) => {
      const { data } = res
      setDetails(data?.[0] ?? data)
      setDetailsLoader(false)
    })
    //eslint-disable-next-line
  }, [])
  return (
    <>
      <PageTitle breadcrumbs={getBreadcrumbs(intl, 'viewPromotion')}>
        {intl.formatMessage({ id: 'PROMOTION.DETAILS' })}
      </PageTitle>
      <KTCardBody>
        <div className='row'>
          {Object.keys(promotionFieldMapping).map((section: string, index: number) => {
            return (
              <div
                className='col-sm-12 col-xs-12 col-md-6 col-lg-6 mb-10 '
                key={`${index}-section`}
              >
                <DetailSection
                  details={details}
                  title={section}
                  fields={promotionFieldMapping[section]}
                  labels={labels}
                  detailsLoader={detailsLoader}
                />
              </div>
            )
          })}
        </div>
      </KTCardBody>
    </>
  )
}
